import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductPriceLists', request)
}

async function put(request) {
    return await putMethod('/api/ownProductPriceLists', request)
}

async function post(body) {
    return await postMethod('/api/ownProductPriceLists', body)
}

export {get, put, post}
